<template>
  <div>
    <div id="sidebar-add-dropdown">
      <vs-dropdown :color="AISEA_COLOR.BLUE" class="w-full">
        <vs-button
            class="w-full"
            icon-pack="feather"
            icon="icon-plus"
            :color="AISEA_COLOR.BLUE"
            >新規登録</vs-button
          >
        <vs-dropdown-menu>
          <vs-dropdown-item @click="showCreateFolderDialog">
            <span class="flex items-center p-2">
              <feather-icon
                icon="FolderPlusIcon"
                svgClasses="h-4 w-4"
                class="mr-2"
              />
              <span>新規フォルダ作成</span>
            </span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="showUploadDialog">
            <span class="flex items-center p-2">
              <feather-icon
                icon="UploadCloudIcon"
                svgClasses="h-4 w-4"
                class="mr-2"
              />
              <span>ファイルアップロード</span>
            </span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>

    <document-uploader-dialog ref="DocumentUploaderDialog">
    </document-uploader-dialog>

    <document-create-folder-dialog ref="DocumentCreateFolderDialog">
    </document-create-folder-dialog>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import DocumentUploaderDialog from "../../dialog/DocumentUploaderDialog"
import DocumentCreateFolderDialog from "../../dialog/DocumentCreateFolderDialog"
import { createNamespacedHelpers } from "vuex";
import FeatherIcon from "../../../../../../../../../../../components/FeatherIcon.vue";
const {
  mapState: mapStateOfEnterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  mixins: [ColorMixin],
  components: {
    DocumentUploaderDialog,
    DocumentCreateFolderDialog,
    FeatherIcon
},
  computed: {
    ...mapStateOfEnterpriseDocumentManager(["currentPath"])
  },
  methods: {
    showUploadDialog () {
      this.$refs.DocumentUploaderDialog.show();
    },

    showCreateFolderDialog () {
      if(this.currentPath.length === 0) {
        this.$refs.DocumentCreateFolderDialog.show("");
        return;
      }
      const path = this.currentPath.map(item => item.name).join("/") + "/";
      this.$refs.DocumentCreateFolderDialog.show(`${path}`)
    },
  },
}
</script>


<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

</style>